import { useComputed } from '@preact/signals-react'

import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import { canDeleteTask } from '../utils/utils.js'

function DeleteTaskModal({ show, handleCancel, handleConfirm, selectedTasks }) {

    const canSubmitComputed = useComputed(() => {
        const taskStatuses = selectedTasks.value.map(task => task.taskStatus)
        // Task status must be greater than Requested (0) and less than Scheduled (15)
        return taskStatuses.every(
            canDeleteTask
        )
    })

    return (
        <Modal
            show={show}
            onHide={handleCancel}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Delete Tasks</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p hidden={!canSubmitComputed.value}>{selectedTasks.value.length} task(s) will be deleted. Are you sure you want to continue?</p>
                <p hidden={canSubmitComputed.value}>Unable to delete tasks that are in process or complete.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
                <Button variant="danger" hidden={!canSubmitComputed.value} onClick={handleConfirm}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteTaskModal;

